module.exports = __webpack_public_path__ + "static/media/uva1.ef295022.png";